import { Card, Col, Row } from 'antd';
import { Rule } from 'antd/es/form';
import FormItem from 'components/form/FormItem';
import FormSelect from 'components/form/FormSelect';
import FormSwitch from 'components/form/FormSwitch';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';
import { formatDateTime } from 'utils/formattedString';

const FormUser = ({
  isEdit,
  currentData,
}: {
  isEdit?: boolean;
  currentData?: DynamicObjectType;
}) => {
  const { t } = useTranslation();

  const validateEmail: Rule[] = useMemo(() => {
    return [
      {
        required: true,
        message: t('input.verificationEmail.validateMsg.required'),
      },
      {
        type: 'email',
        message: t('input.verificationEmail.validateMsg.invalid'),
      },
    ];
  }, [t]);
  return (
    <Row gutter={[16, 0]} className="mt-5">
      <Col span={isEdit ? 16 : 24}>
        <Card title="User infomation">
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <FormItem label="First name" name="firstName" required />
            </Col>
            <Col span={12}>
              <FormItem label="Last name" name="lastName" required />
            </Col>
            <Col span={12}>
              <FormItem label="Email" name="email" rules={validateEmail} />
            </Col>
            {/* <Col span={12}>
              <FormItem label="Phone" name="phoneNumber" />
            </Col> */}
            {/* {!isEdit && (
              <Col md={12}>
                <FormItem required label="Password" name="password" />
              </Col>
            )} */}
            <Col span={12}>
              <FormSelect
                reference={{
                  labelProp: 'name',
                  model: 'chain-stores',
                  searchKey: 'name',
                  childFormKey: 'id',
                  allowClear: true,
                }}
                label={t('mores.locations.brand.label')}
                name="chainStore"
                placeholder={t('mores.locations.brand.placeholder')}
                type="array"
              />
            </Col>
            <Col span={12}>
              <FormSelect
                reference={{
                  labelProp: 'name',
                  model: `locations`,
                  searchKey: 'name',
                  allowClear: true,
                  labelFormat: (item) => (
                    <div>
                      {item?.name ? `${item?.name} | ${item?.id}` : item?.id}
                    </div>
                  ),
                }}
                label={t('users.location')}
                name="locationCode"
                placeholder={t('mores.locations.brand.placeholder')}
                type="array"
              />
            </Col>
            <Col span={12}>
              <FormSelect
                label="Role"
                name="roles"
                reference={{
                  labelProp: 'name',
                  model: 'roles',
                  searchKey: 'name',
                  valueProp: 'id',
                  allowClear: true,
                  initFilters: {
                    join: [],
                    filters: [
                      {
                        condition: 'and',
                        operator: 'is',
                        key: 'isActive',
                        value: true,
                      },
                    ],
                  },
                }}
                type="array"
                required
              />
            </Col>
            <Col span={12}>
              <FormSwitch label="Active status" name="isActive" />
            </Col>
          </Row>
        </Card>
      </Col>
      {isEdit && (
        <Col span={8}>
          <Card title="Creator">
            <div>{`${
              currentData?.createdBy?.firstName || ''
            } ${currentData?.createdBy?.lastName || ''}`}</div>
            <div className="text-light-gray">
              {currentData?.createdBy?.email}
            </div>
            <div className="d-flex flex-center-between">
              <div>Creation Date</div>
              <div>{formatDateTime(currentData?.createdAt)}</div>
            </div>
          </Card>
        </Col>
      )}
    </Row>
  );
};

export default FormUser;
